import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from '@redux-devtools/extension'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import createSagaMiddleware from 'redux-saga'
import { all } from 'redux-saga/effects'
import rootReducer from 'components/store/state/rootReducer'
import coreSaga from 'components/core/state/saga'

const persistConfig = {
  key: 'adent.appointment-form.root',
  storage,
}

const sagaMiddleware = createSagaMiddleware()
const persistedReducer = persistReducer(persistConfig, rootReducer)
const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(sagaMiddleware)))
const persistedStore = persistStore(store)
persistedStore.purge()

sagaMiddleware.run(function* listenForSagas() {
  yield all([
    coreSaga(),
  ])
})

export type AppDispatch = typeof store.dispatch

export {
  persistedStore,
  store,
}
